import React from "react";
import StartLoggedIn from "../start/StartLoggedIn";
import Start from "../start/Start";
import { useAuth0 } from "@auth0/auth0-react";

export default function HomePage() {
  const { user } = useAuth0();

  return user ? (<StartLoggedIn />) : (<Start />);
}
